// https://www.stimulus-components.com/docs/stimulus-password-visibility

import PasswordVisibility from '@stimulus-components/password-visibility'

export default class extends PasswordVisibility {

  connect() {
    this.waitForElements()
  }

  waitForElements() {
    if (this.hasInputTarget && this.hasConfirmationInputTarget) {
      super.connect()
      // super lets you call methods from the parent PasswordVisibility
      this.hidden = this.inputTarget.type === "password" && this.confirmationInputTarget.type === "password"
    } else {
      // Retry after a short delay
      setTimeout(() => this.waitForElements(), 100)
    }
  }


  // Only toggle inside the same .form-row (not the entire controller scope)
  toggle(event) {
    const button = event.currentTarget
    const form_row = button.closest('.form-row')
    const input =  form_row.querySelector('input[type="password"], input[type="text"]')

    input.type = input.type === 'password' ? 'text' : 'password'

    form_row.querySelectorAll('.eye-icon').forEach(icon => icon.classList.toggle('hidden'))
  }
}